import { Module } from 'vuex-smart-module';
import OrganizationCheckActions from './actions';
import OrganizationCheckGetters from './getters';
import OrganizationCheckMutations from './mutations';
import OrganizationCheckState from './state';

export default new Module({
  state: OrganizationCheckState,
  mutations: OrganizationCheckMutations,
  actions: OrganizationCheckActions,
  getters: OrganizationCheckGetters,
});
